document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountdown();
  initGallery();
  initVariantPicker();
  initAccordion();
});

function initReveal() {
  var els = document.querySelectorAll('.hw-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('hw-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hw-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });
}

function initCountdown() {
  document.querySelectorAll('[data-hw-countdown]').forEach(function (wrap) {
    var target = new Date(wrap.getAttribute('data-hw-countdown')).getTime();
    if (isNaN(target)) return;
    var dEl = wrap.querySelector('[data-hw-d]');
    var hEl = wrap.querySelector('[data-hw-h]');
    var mEl = wrap.querySelector('[data-hw-m]');
    var sEl = wrap.querySelector('[data-hw-s]');
    function tick() {
      var diff = target - Date.now();
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = String(d).padStart(2, '0');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });
}

function initGallery() {
  document.querySelectorAll('[data-hw-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-hw-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-hw-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-hw-full') || thumb.src;
        main.src = full;
        thumbs.forEach(function (t) { t.classList.remove('hw-thumb-active'); });
        thumb.classList.add('hw-thumb-active');
      });
    });
  });
}

function initVariantPicker() {
  document.querySelectorAll('[data-hw-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-hw-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-hw-variant-id]');
    var priceEl = root.querySelector('[data-hw-price]');
    var compareEl = root.querySelector('[data-hw-price-compare]');
    var submitBtn = root.querySelector('[data-hw-submit]');
    var stockMsg = root.querySelector('[data-hw-stock-msg]');
    var swatches = root.querySelectorAll('[data-hw-option-value]');

    function currentSelection() {
      var selection = {};
      root.querySelectorAll('[data-hw-option-index]').forEach(function (group) {
        var idx = group.getAttribute('data-hw-option-index');
        var active = group.querySelector('.hw-active');
        if (active) selection[idx] = active.getAttribute('data-hw-option-value');
      });
      return selection;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return Object.keys(selection).every(function (idx) {
          return v.options[parseInt(idx, 10)] === selection[idx];
        });
      });
    }

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.hwCurrency || 'USD' });
    }

    function updateUI() {
      var selection = currentSelection();
      var variant = findVariant(selection);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? submitBtn.getAttribute('data-hw-label-available') : submitBtn.getAttribute('data-hw-label-soldout');
      }
      if (stockMsg) {
        stockMsg.className = 'hw-stock-msg';
        if (!variant.available) {
          stockMsg.textContent = stockMsg.getAttribute('data-hw-out-text') || 'Out of stock';
          stockMsg.classList.add('hw-out');
        } else {
          stockMsg.textContent = '';
        }
      }
      swatches.forEach(function (sw) {
        var idx = sw.closest('[data-hw-option-index]').getAttribute('data-hw-option-index');
        var val = sw.getAttribute('data-hw-option-value');
        var testSelection = Object.assign({}, selection);
        testSelection[idx] = val;
        var testVariant = findVariant(testSelection);
        sw.disabled = !testVariant || !testVariant.available;
      });
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var group = sw.closest('[data-hw-option-index]');
        group.querySelectorAll('.hw-swatch').forEach(function (s) { s.classList.remove('hw-active'); });
        sw.classList.add('hw-active');
        updateUI();
      });
    });

    updateUI();
  });
}

function initAccordion() {
  document.querySelectorAll('.hw-accordion-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.hw-accordion-item');
      var wasOpen = item.classList.contains('hw-open');
      item.parentElement.querySelectorAll('.hw-accordion-item').forEach(function (i) { i.classList.remove('hw-open'); });
      if (!wasOpen) item.classList.add('hw-open');
    });
  });
}
